// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8acc5655","404":"acc241f4","498":"6addbe94","787":"d5fa4d18"}[chunkId] + ".chunk.js";
};